import { render } from "./SettingsModule.vue?vue&type=template&id=762301e9&scoped=true"
import script from "./SettingsModule.vue?vue&type=script&lang=js"
export * from "./SettingsModule.vue?vue&type=script&lang=js"

import "./SettingsModule.vue?vue&type=style&index=0&id=762301e9&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-762301e9"

export default script